// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* TODO: Create tailwind styles for this component */
.sb-topLeft {
  top: 0;
  left: 0;
  bottom: auto;
  right: auto;
}
.sb-topCenter {
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
  top: 0;
  bottom: auto;
  left: 50%;
}
.sb-topRight {
  right: 0;
  top: 0;
  left: auto;
  bottom: auto;
}
.sb-bottomLeft {
  right: auto;
  left: 0;
  bottom: 0;
  top: auto;
}
.sb-bottomCenter {
  top: auto;
  bottom: 0;
  left: 50%;
  -webkit-transform: translateX(-50%);
          transform: translateX(-50%);
}
.sb-bottomRight {
  margin: 10px 0 0;
  top: auto;
  bottom: 0;
  left: auto;
  right: 0;
}
.sb-topLeft .sb-item,
.sb-topCenter .sb-item,
.sb-topRight .sb-item {
  margin: 10px 0 0;
}
.sb-bottomLeft .sb-item,
.sb-bottomCenter .sb-item,
.sb-bottomRight .sb-item {
  margin: 0 0 10px;
}
.sb-closeBtn:hover {
  background: #fff;
}
.sb-item {
  -webkit-animation: fadein 1s;
          animation: fadein 1s;
  -webkit-box-shadow:
    0 6px 10px 0 rgba(0, 0, 0, 0.2),
    0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 3px 5px -1px rgba(0, 0, 0, 0.14);
          box-shadow:
    0 6px 10px 0 rgba(0, 0, 0, 0.2),
    0 1px 18px 0 rgba(0, 0, 0, 0.12),
    0 3px 5px -1px rgba(0, 0, 0, 0.14);
  position: relative;
  overflow: hidden;
  border-radius: 0.375rem;
  padding: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
  -webkit-transition-property: height;
  transition-property: height;
  -webkit-transition-duration: 300ms;
          transition-duration: 300ms;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
          transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
@-webkit-keyframes fadein {
  from {
    top: 30px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
@keyframes fadein {
  from {
    top: 30px;
    opacity: 0;
  }
  to {
    top: 0;
    opacity: 1;
  }
}
/* Internet Explorer */
`, "",{"version":3,"sources":["webpack://./../../ui/src/components/Snackbar/Snackbar.css"],"names":[],"mappings":"AAAA,oDAAoD;AAElD;EAAA,MAA0C;EAA1C,OAA0C;EAA1C,YAA0C;EAA1C;AAA0C;AAG5C;EACE,mCAA2B;UAA3B,2BAA2B;EAC3B,MAAiC;EAAjC,YAAiC;EAAjC,SAAiC;AACnC;AAGE;EAAA,QAA0C;EAA1C,MAA0C;EAA1C,UAA0C;EAA1C;AAA0C;AAI1C;EAAA,WAA0C;EAA1C,OAA0C;EAA1C,SAA0C;EAA1C;AAA0C;AAI1C;EAAA,SAAiC;EAAjC,SAAiC;EAAjC,SAAiC;EACjC,mCAA2B;UAA3B;AADiC;AAInC;EACE,gBAAgB;EAChB,SAA0C;EAA1C,SAA0C;EAA1C,UAA0C;EAA1C,QAA0C;AAC5C;AAEA;;;EAGE,gBAAgB;AAClB;AAEA;;;EAGE,gBAAgB;AAClB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,4BAAoB;UAApB,oBAAoB;EACpB;;;sCAGoC;UAHpC;;;sCAGoC;EACpC,kBAAoG;EAApG,gBAAoG;EAApG,uBAAoG;EAApG,gBAAoG;EAApG,oBAAoG;EAApG,gDAAoG;EAApG,mCAAoG;EAApG,2BAAoG;EAApG,kCAAoG;UAApG,0BAAoG;EAApG,gEAAoG;UAApG,wDAAoG;AACtG;AAEA;EACE;IACE,SAAS;IACT,UAAgB;EAClB;EAEE;IAAA,MAAwB;IAAxB;EAAwB;AAE5B;AARA;EACE;IACE,SAAS;IACT,UAAgB;EAClB;EAEE;IAAA,MAAwB;IAAxB;EAAwB;AAE5B;AAEA,sBAAsB","sourcesContent":["/* TODO: Create tailwind styles for this component */\n.sb-topLeft {\n  @apply top-0 left-0 bottom-auto right-auto;\n}\n\n.sb-topCenter {\n  transform: translateX(-50%);\n  @apply top-0 bottom-auto left-1/2;\n}\n\n.sb-topRight {\n  @apply right-0 top-0 left-auto bottom-auto;\n}\n\n.sb-bottomLeft {\n  @apply right-auto left-0 bottom-0 top-auto;\n}\n\n.sb-bottomCenter {\n  @apply top-auto bottom-0 left-1/2;\n  transform: translateX(-50%);\n}\n\n.sb-bottomRight {\n  margin: 10px 0 0;\n  @apply top-auto bottom-0 left-auto right-0;\n}\n\n.sb-topLeft .sb-item,\n.sb-topCenter .sb-item,\n.sb-topRight .sb-item {\n  margin: 10px 0 0;\n}\n\n.sb-bottomLeft .sb-item,\n.sb-bottomCenter .sb-item,\n.sb-bottomRight .sb-item {\n  margin: 0 0 10px;\n}\n\n.sb-closeBtn:hover {\n  background: #fff;\n}\n\n.sb-item {\n  animation: fadein 1s;\n  box-shadow:\n    0 6px 10px 0 rgba(0, 0, 0, 0.2),\n    0 1px 18px 0 rgba(0, 0, 0, 0.12),\n    0 3px 5px -1px rgba(0, 0, 0, 0.14);\n  @apply transition-height relative overflow-hidden rounded-md p-3 text-white duration-300 ease-in-out;\n}\n\n@keyframes fadein {\n  from {\n    top: 30px;\n    @apply opacity-0;\n  }\n  to {\n    @apply top-0 opacity-100;\n  }\n}\n\n/* Internet Explorer */\n@-ms-keyframes fadein {\n  from {\n    top: 30px;\n    @apply opacity-0;\n  }\n  to {\n    @apply opacity-100;\n    top: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
